import {ValidatorModel} from "../common/models/validator";
import Validator from "./validator";
import {makeAutoObservable} from "mobx";

export class ValidatedValue<Type> {
    value: Type;
    errorMessage?: string = "";
    validators?: ValidatorModel[];

    constructor(value: Type, validators?: ValidatorModel[]) {
        makeAutoObservable(this);
        this.value = value;
        this.validators = validators;
    }

    setValue(value: Type) {
        this.value = value;
    }

    setErrorMessage(value: string) {
        this.errorMessage = value;
    }

    addValidators(validator: ValidatorModel | ValidatorModel[]) {
        if (Array.isArray(validator)) {
            if (this.validators) {
                this.validators.push(...validator);
            } else {
                this.validators = validator;
            }
        } else if (this.validators) {
            this.validators.push(validator);
        } else {
            this.validators = [validator];
        }
    }

    removeValidators() {
        this.validators = [];
    }

    clearValidation() {
        this.errorMessage = "";
    }

    validate() {
        if (this.validators) {
            this.errorMessage = Validator.validate(this.value, this.validators);
        }
    }

    get isValid() {
        return !this.errorMessage;
    }
}
